module.exports = "/images/vendor/desiigner-svg/svg/social/flipboard.svg?39c9cbd91cdc2375577bcb41051c08b2";